import styled, { css } from 'styled-components';

export const UserCardWrapper = styled.div<{ $isActive?: boolean }>`
  &&& {
    .ant-card {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 20px;
      gap: 8px;
      background: var(--v3-black-0);
      border-radius: 16px;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      margin-bottom: 16px;
      cursor: pointer;
      border: 1px solid var(--v3-black-2);

      ${props =>
        props.$isActive &&
        css`
          border: 1px solid var(--v3-primary-color);
        `}
      .ant-card-body {
        padding: 0;
      }

      .ant-card-meta {
        align-items: center;
      }

      .ant-card-meta-avatar {
        width: 72px;
        height: 72px;
        padding: 0;
        margin-right: 12px;

        & > img {
          width: 100%;
          height: 100%;
        }
      }

      .ant-card-meta-title {
        font-weight: 800;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: -0.01em;
        color: var(--v3-black);
        flex: none;
        order: 0;
        flex-grow: 0;
        margin-bottom: 4px;
        white-space: break-spaces;
      }

      .ant-card-meta-description {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: -0.01em;
        color: var(--v3-black-45);
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
      }

      .ant-card-meta-detail {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
`;
